import { __assign, __rest } from "tslib";
import React from 'react';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
import InternalTokenGroup from './internal';
export default function TokenGroup(_a) {
    var _b = _a.alignment, alignment = _b === void 0 ? 'horizontal' : _b, props = __rest(_a, ["alignment"]);
    var baseComponentProps = useBaseComponent('TokenGroup');
    return React.createElement(InternalTokenGroup, __assign({ alignment: alignment }, props, baseComponentProps));
}
applyDisplayName(TokenGroup, 'TokenGroup');
//# sourceMappingURL=index.js.map